import { c as e } from "react/compiler-runtime";
import { InteractionRequiredAuthError as t, InteractionStatus as n, InteractionType as r, LogLevel as i, createStandardPublicClientApplication as a } from "@azure/msal-browser";
import { MsalAuthenticationTemplate as o, MsalProvider as s, useMsal as c } from "@azure/msal-react";
import { createContext as l, useContext as u, useEffect as d, useState as f } from "react";
import { jsx as p, jsxs as m } from "react/jsx-runtime";
//#region src/config/Config.ts
var h = {
	Local: "local",
	Dev: "dev",
	Stg: "stg",
	Prd: "prd"
}, g = (e) => {
	let t = new URL(e).hostname;
	return t === "localhost" || t === "127.0.0.1" ? h.Local : t.startsWith("dev.") ? h.Dev : t.startsWith("stg.") ? h.Stg : h.Prd;
}, _ = (e) => e !== h.Prd, v = l({
	getAuthToken: async () => {
		throw Error("getAuthToken not initialized");
	},
	logout: async () => {
		throw Error("logout not initialized");
	},
	userAccount: {}
}), y = {
	alignContent: "center",
	boxSizing: "border-box",
	display: "grid",
	gap: "1rem",
	justifyItems: "center",
	minHeight: "100vh",
	padding: "2rem",
	textAlign: "center"
}, b = (e, t) => {
	let n = t, r = "unknown_error";
	typeof n?.errorCode == "string" ? r = n.errorCode : t instanceof Error && (r = t.name), console.error(e, {
		errorCode: r,
		subError: typeof n?.subError == "string" ? n.subError : void 0,
		correlationId: typeof n?.correlationId == "string" ? n.correlationId : void 0
	});
}, x = () => {
	let t = e(1), n;
	return t[0] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ p("div", {
		role: "status",
		"aria-live": "polite",
		style: y,
		children: "Signing in..."
	}), t[0] = n) : n = t[0], n;
}, S = () => {
	let t = e(1), n;
	return t[0] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("div", {
		role: "alert",
		style: y,
		children: [/* @__PURE__ */ p("p", { children: "Unable to sign in" }), /* @__PURE__ */ p("button", {
			type: "button",
			onClick: w,
			children: "Try again"
		})]
	}), t[0] = n) : n = t[0], n;
}, C = ({ onRetry: e, onSignInAgain: t }) => {
	let [n, r] = f(), [i, a] = f(!1), o = async (e, t) => {
		r(e), a(!1);
		try {
			await t();
		} catch (e) {
			b("Authentication recovery failed", e), a(!0);
		} finally {
			r(void 0);
		}
	};
	return /* @__PURE__ */ m("div", {
		role: "alert",
		"aria-busy": n !== void 0,
		style: y,
		children: [
			/* @__PURE__ */ p("p", { children: "Unable to sign in" }),
			e && /* @__PURE__ */ p("button", {
				type: "button",
				disabled: n !== void 0,
				onClick: () => void o("retry", e),
				children: n === "retry" ? "Trying again..." : "Try again"
			}),
			/* @__PURE__ */ p("button", {
				type: "button",
				disabled: n !== void 0,
				onClick: () => void o("signIn", t),
				children: n === "signIn" ? "Signing in..." : "Sign in again"
			}),
			i && /* @__PURE__ */ p("p", {
				role: "status",
				children: "Sign-in could not be restarted. Please try again."
			})
		]
	});
};
function w() {
	return window.location.reload();
}
//#endregion
//#region src/msal/GetMsalAuthToken.ts
var T = (e, r, i) => {
	let a, o = n.None;
	return {
		getAuthToken: async () => {
			let s = {
				scopes: i,
				account: e
			};
			try {
				return (await r.acquireTokenSilent(s)).accessToken;
			} catch (e) {
				throw e instanceof t ? (!a && o === n.None && (a = r.acquireTokenRedirect(s).finally(() => {
					a = void 0;
				})), a && await a, e) : e;
			}
		},
		setInteractionStatus: (e) => {
			o = e;
		}
	};
}, E = (t) => {
	let n = e(23), { account: r, children: i, inProgress: a, instance: o, scopes: s } = t, c;
	n[0] !== r || n[1] !== o || n[2] !== s ? (c = T(r, o, s), n[0] = r, n[1] = o, n[2] = s, n[3] = c) : c = n[3];
	let l = c;
	l.setInteractionStatus(a);
	let u = l.getAuthToken, d;
	n[4] !== r || n[5] !== o ? (d = (e) => o.logoutRedirect({
		account: r,
		postLogoutRedirectUri: e
	}), n[4] = r, n[5] = o, n[6] = d) : d = n[6];
	let f = d, m = r.idTokenClaims, h = m?.given_name, g = m?.family_name, _ = `${m?.given_name} ${m?.family_name}`, y = m?.user, b = m?.userType, x = m?.agent, S = m?.agency, C = m?.roles, w;
	n[7] !== C || n[8] !== h || n[9] !== g || n[10] !== _ || n[11] !== y || n[12] !== b || n[13] !== x || n[14] !== S ? (w = {
		firstName: h,
		lastName: g,
		fullName: _,
		user: y,
		userType: b,
		agent: x,
		agency: S,
		roles: C
	}, n[7] = C, n[8] = h, n[9] = g, n[10] = _, n[11] = y, n[12] = b, n[13] = x, n[14] = S, n[15] = w) : w = n[15];
	let E = w, D;
	n[16] !== u || n[17] !== f || n[18] !== E ? (D = {
		getAuthToken: u,
		logout: f,
		userAccount: E
	}, n[16] = u, n[17] = f, n[18] = E, n[19] = D) : D = n[19];
	let O = D, k;
	return n[20] !== O || n[21] !== i ? (k = /* @__PURE__ */ p(v.Provider, {
		value: O,
		children: i
	}), n[20] = O, n[21] = i, n[22] = k) : k = n[22], k;
}, D = (t) => {
	let n = e(33), { children: r, scopes: i } = t, { accounts: a, inProgress: o, instance: s } = c(), l;
	n[0] === s ? l = n[1] : (l = s.getActiveAccount(), n[0] = s, n[1] = l);
	let u = l, f;
	if (n[2] !== a || n[3] !== u) {
		if (u) {
			let e;
			n[5] === u ? e = n[6] : (e = (e) => e.homeAccountId === u.homeAccountId && e.localAccountId === u.localAccountId && e.username === u.username, n[5] = u, n[6] = e), f = a.find(e);
		} else a.length === 1 && (f = a[0]);
		n[2] = a, n[3] = u, n[4] = f;
	} else f = n[4];
	let m;
	n[7] !== a[0] || n[8] !== a.length || n[9] !== u || n[10] !== s ? (m = () => {
		!u && a.length === 1 && s.setActiveAccount(a[0]);
	}, n[7] = a[0], n[8] = a.length, n[9] = u, n[10] = s, n[11] = m) : m = n[11];
	let h;
	n[12] !== a || n[13] !== u || n[14] !== s ? (h = [
		a,
		u,
		s
	], n[12] = a, n[13] = u, n[14] = s, n[15] = h) : h = n[15], d(m, h);
	let g;
	n[16] !== f || n[17] !== a.length ? (g = () => {
		!f && a.length > 1 && console.error("Authentication account selection failed", {
			errorCode: "multiple_cached_accounts",
			subError: "active_account_missing",
			correlationId: void 0
		});
	}, n[16] = f, n[17] = a.length, n[18] = g) : g = n[18];
	let _;
	n[19] !== f || n[20] !== a.length ? (_ = [f, a.length], n[19] = f, n[20] = a.length, n[21] = _) : _ = n[21], d(g, _);
	let v;
	n[22] !== s || n[23] !== i ? (v = async () => {
		await s.clearCache(), await s.loginRedirect({
			scopes: i,
			prompt: "login"
		});
	}, n[22] = s, n[23] = i, n[24] = v) : v = n[24];
	let y = v;
	if (!f) {
		let e;
		return n[25] === y ? e = n[26] : (e = /* @__PURE__ */ p(C, { onSignInAgain: y }), n[25] = y, n[26] = e), e;
	}
	let b;
	return n[27] !== f || n[28] !== r || n[29] !== o || n[30] !== s || n[31] !== i ? (b = /* @__PURE__ */ p(E, {
		account: f,
		inProgress: o,
		instance: s,
		scopes: i,
		children: r
	}), n[27] = f, n[28] = r, n[29] = o, n[30] = s, n[31] = i, n[32] = b) : b = n[32], b;
}, O = l(void 0), k = () => {
	let e = u(O);
	if (!e) throw Error("Authentication request is not initialized");
	return e;
}, A = (t) => {
	let n = e(14), { acquireToken: i, error: a, login: o } = t, { accounts: s, instance: l } = c(), u = k(), f, m;
	n[0] === a ? (f = n[1], m = n[2]) : (f = () => {
		b("Authentication failed", a);
	}, m = [a], n[0] = a, n[1] = f, n[2] = m), d(f, m);
	let h;
	n[3] !== s.length || n[4] !== i || n[5] !== o ? (h = async () => {
		s.length > 0 ? await i(r.Redirect) : await o(r.Redirect);
	}, n[3] = s.length, n[4] = i, n[5] = o, n[6] = h) : h = n[6];
	let g = h, _;
	n[7] !== u || n[8] !== l || n[9] !== o ? (_ = async () => {
		await l.clearCache(), await o(r.Redirect, {
			...u,
			prompt: "login"
		});
	}, n[7] = u, n[8] = l, n[9] = o, n[10] = _) : _ = n[10];
	let v = _, y;
	return n[11] !== g || n[12] !== v ? (y = /* @__PURE__ */ p(C, {
		onRetry: g,
		onSignInAgain: v
	}), n[11] = g, n[12] = v, n[13] = y) : y = n[13], y;
}, j = ({ authClientId: e, authInstance: t, authDomain: n, authSignupSigninPolicyId: r, envSigninPrefix: a, authEnableLogs: o }) => {
	if (!e) throw Error("authClientId is not set");
	if (!t) throw Error("authInstance is not set");
	if (!n) throw Error("authDomain is not set");
	if (!r) throw Error("authSignupSigninPolicyId is not set");
	if (!a) throw Error("envSigninPrefix is not set");
	let s;
	try {
		s = new URL(a);
	} catch {
		throw Error("envSigninPrefix must be an absolute URL ending in /redirect.html");
	}
	if (!s.pathname.endsWith("/redirect.html") || s.search !== "" || s.hash !== "") throw Error("envSigninPrefix must be an absolute URL ending in /redirect.html");
	let c = o === "true";
	return {
		auth: {
			clientId: e,
			authority: `https://${t}/${n}/${r}`,
			knownAuthorities: [t],
			redirectUri: s.href
		},
		cache: { cacheLocation: "localStorage" },
		system: { loggerOptions: { loggerCallback: (e, t, n) => {
			if (c && !n) switch (e) {
				case i.Error:
					console.error(t);
					return;
				case i.Info:
					console.info(t);
					return;
				case i.Verbose:
					console.debug(t);
					return;
				case i.Warning:
					console.warn(t);
					return;
				default: return;
			}
		} } }
	};
}, M = ({ userIdClaim: e, userTypeClaim: t, agencyClaim: n, rolesClaim: r }) => ({
	firstName: "Local",
	lastName: "User",
	fullName: "Local User",
	user: e,
	userType: t,
	agent: e,
	agency: n,
	roles: r?.split(",").map((e) => e.trim()).filter(Boolean)
}), N = (t) => {
	let n = e(7), { children: r, apiConfig: i } = t, a = I, o = L, s;
	n[0] === i ? s = n[1] : (s = M(i), n[0] = i, n[1] = s);
	let c = s, l;
	n[2] === c ? l = n[3] : (l = {
		getAuthToken: a,
		logout: o,
		userAccount: c
	}, n[2] = c, n[3] = l);
	let u = l, d;
	return n[4] !== u || n[5] !== r ? (d = /* @__PURE__ */ p(v.Provider, {
		value: u,
		children: r
	}), n[4] = u, n[5] = r, n[6] = d) : d = n[6], d;
}, P = ({ children: e, apiConfig: t }) => {
	let [n, i] = f(), [c, l] = f(!1);
	return d(() => {
		let e = (e) => {
			b("Failed to initialize authentication", e), l(!0);
		};
		try {
			if (!t.authAppUri) throw Error("authAppUri is not set");
			let n = { scopes: [`${t.authAppUri}/openid`] };
			a(j(t)).then((e) => i({
				instance: e,
				authenticationRequest: n
			}), e);
		} catch (t) {
			e(t);
		}
	}, [t]), c ? /* @__PURE__ */ p(S, {}) : n ? /* @__PURE__ */ p(s, {
		instance: n.instance,
		children: /* @__PURE__ */ p(O.Provider, {
			value: n.authenticationRequest,
			children: /* @__PURE__ */ p(o, {
				interactionType: r.Redirect,
				authenticationRequest: n.authenticationRequest,
				loadingComponent: x,
				errorComponent: A,
				children: /* @__PURE__ */ p(D, {
					scopes: n.authenticationRequest.scopes,
					children: e
				})
			})
		})
	}) : /* @__PURE__ */ p(x, {});
}, F = (t) => {
	let n = e(6), { children: r, apiConfig: i } = t;
	if (i.devMode && i.userIdClaim && i.userTypeClaim) {
		let e;
		return n[0] !== i || n[1] !== r ? (e = /* @__PURE__ */ p(N, {
			apiConfig: i,
			children: r
		}), n[0] = i, n[1] = r, n[2] = e) : e = n[2], e;
	}
	let a;
	return n[3] !== i || n[4] !== r ? (a = /* @__PURE__ */ p(P, {
		apiConfig: i,
		children: r
	}), n[3] = i, n[4] = r, n[5] = a) : a = n[5], a;
};
async function I() {
	return "local-dev-auth";
}
async function L(e) {
	window.location.assign(e);
}
//#endregion
//#region src/api/AuthorizedApiBase.ts
var R = ({ userIdClaim: e, userTypeClaim: t, agencyClaim: n, rolesClaim: r }) => {
	let i = {};
	return e !== void 0 && (i["x-claim-userId"] = e), t !== void 0 && (i["x-claim-userType"] = t), n !== void 0 && (i["x-claim-agency"] = n), r !== void 0 && (i["x-claim-roles"] = r), i;
}, z = class {
	getAuthTokenFunction = void 0;
	devHeaders = {};
	constructor() {}
	transformOptions = async (e) => {
		if (!this.getAuthTokenFunction) throw Error("No getAuthTokenFunction has been provided");
		let t = await this.getAuthTokenFunction();
		return e.headers = {
			...e.headers,
			...this.devHeaders,
			Authorization: `Bearer ${t}`
		}, Promise.resolve(e);
	};
	setAuthConfig = (e, t) => {
		this.getAuthTokenFunction = e, this.devHeaders = R(t);
	};
	async transformResult(e, t, n) {
		let r = String(t.headers?.["content-type"] ?? "").toLowerCase(), i = t.data;
		return t.status >= 200 && t.status < 300 && r.includes("application/json") && typeof i == "object" && i ? i : await Promise.resolve(n(t));
	}
}, B = /* @__PURE__ */ function(e) {
	return e.Director = "director", e.SalesAgent = "salesagent", e.Admin = "admin", e;
}({}), V = /* @__PURE__ */ function(e) {
	return e.BusinessManager = "businessmanager", e.AdminManager = "adminmanager", e.MarketingExpert = "marketingexpert", e.ListingsContributor = "listingscontributor", e.LaunchContributor = "launchcontributor", e.ContractsContributor = "contractscontributor", e.TransactionsContributor = "transactionscontributor", e.FinanceContributor = "financecontributor", e.WorkflowContributor = "workflowcontributor", e.Executive = "executive", e.SuperAdmin = "superadmin", e;
}({});
//#endregion
export { B as AgentRole, F as AgxAuth, h as AgxEnvironments, v as AuthContext, z as AuthorizedApiBase, V as StaffRole, _ as isNonProductionEnvironment, g as resolveAgxEnvironment };

//# sourceMappingURL=index.js.map